import React, { useState, useEffect, useRef} from "react";
import {Box,Card,CardContent,Typography,Table,TableBody,TableCell,TableContainer,TableSortLabel,TablePagination,TableHead,TableRow,Paper,TextField,InputAdornment,Dialog,DialogTitle,CircularProgress,Button,IconButton} from "@material-ui/core";
import {Error} from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import config from "../config";
import {getInactiveUsersDataFromTable, archiveInactiveUsersData} from "./RestService";
import { useMsal } from "@azure/msal-react";
import {GlobalUseStyles} from "./GlobalUseStyles.js";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { snackbar } from "../snackbarService";

const useStyles = makeStyles((theme) => ({
    root: {
        "& > .MuiAutocomplete-root .MuiFormControl-root .MuiInputBase-root": {
            flexWrap: "nowrap",
          overflowX: "hidden",  // or "hidden"
          padding: "0px 5px"
        },
        "& .MuiInputBase-input": {
            height: "10px"
        }
      },
  
    select: {
      padding: "0 8px"
    },
    
    paper: {
        marginBottom: "0px",
        flex: "1",
        justifyContent: "start",
        alignItems: "left",
    },
    excelList: {
        paddingTop: "20px",
        justifyContent: "flex-end"
    },
    materialDropdown: {
        minWidth: "200px",
        maxWidth: "200px",
        display: "inline-block"
    },
    topBarItem: {
        marginRight: "20px"
    },
    blueButton: {
        backgroundColor: "#0071B9",
        color: "#fff",
        fontWeight: 'bold',
        '&:hover': {
            backgroundColor: '#009dff',
            borderColor: '#009d00',
            boxShadow: 'none',
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#4dbbff',
            borderColor: '#4dbb00',
        },
    },
    
    addIcon: {

    },
    textField: {
        minHeight: "24px",
        maxHeight: "32px",
        marginRight: "32px"
    },
    inputStyle: {
        height: "8px",
    },
}));

export default function AdminActions(props) {

    const globalClasses = GlobalUseStyles();
    const classes = useStyles();
    const {instance, accounts } = useMsal();
    const [inactiveUsersData, setInactiveUsersData] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);

    const allSelected = inactiveUsersData.length > 0 && selectedEmails.length === inactiveUsersData.length;

    const GetInactiveUsersDataFromTable = async (event) => {  
        const inactiveUsersData = await getInactiveUsersDataFromTable(instance, accounts[0].username);
        setInactiveUsersData(inactiveUsersData);
        console.log("Finished");
    }

    useEffect(() => {
        GetInactiveUsersDataFromTable();
    }, []);

    const ArchiveInactiveUsersData = async (event) => {
        if (selectedEmails.length === 0) {
            alert("Please select at least one user.");
            return;
        }
        const ok = window.confirm("Are you sure you want to archieve inactive users ?");
        if (!ok) return;
        var selectedEmailIDs=JSON.stringify(selectedEmails).toString();
        const status = await archiveInactiveUsersData(instance, accounts[0].username, selectedEmailIDs);
        const inactiveUsersData = await getInactiveUsersDataFromTable(instance, accounts[0].username);
        setInactiveUsersData(inactiveUsersData);
        setSelectedEmails([]);
        if(status!=null && status=="Done") {
            snackbar.success("Archival successful",300000);
        } else {
            snackbar.error("Archival failed",300000);
        }
        console.log("Completed");
    }

    const handleCheckboxChange = (email) => {
        setSelectedEmails(prev => {
          if (prev.includes(email)) {
            return prev.filter(e => e !== email);
          }
          return [...prev, email];
        });
      };
    
    const handleSelectAll = () => {
        if (allSelected) {
          setSelectedEmails([]);
        } else {
          const allEmails = inactiveUsersData.map(u => u.userid);
          setSelectedEmails(allEmails);
        }
      };
    
    return (
        
        <Box p={2} style={{ marginleft:10 , paddingTop:20, paddingBottom:15 }}>
            <div className={globalClasses.textBar}>
                <Typography variant="h5" color="textPrimary" align="left">
                    {'Admin Archive Actions'}
                </Typography>
                <div className={globalClasses.createTestButtonDiv}>
                    <Button variant="contained" className={clsx(classes.topBarItem, globalClasses.blueButton)} onClick={(event) => {ArchiveInactiveUsersData(event);}}>
                        <IconButton className={classes.addIcon} /> Archive Inactive Users
                    </Button>
                </div>
            </div>            
            <div style={{ textAlign: "left" }}>

            <TableContainer style={{ maxHeight : 350 }}>
                <Table stickyHeader>
                <TableHead style={{background: 'aliceblue !important'}}>
                    <TableRow>
                    <TableCell>
                        <input type="checkbox" checked={allSelected} onChange={handleSelectAll} />
                    </TableCell>
                    <TableCell>
                        Name
                    </TableCell>
                    <TableCell>
                        Email ID
                    </TableCell>
                    <TableCell>
                        Count
                    </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {inactiveUsersData?.length > 0 ? ( inactiveUsersData.map((row, index) => (
                        <TableRow key={index}>
                            <TableCell>
                                <input type="checkbox" checked={selectedEmails.includes(row.userid)} onChange={() => handleCheckboxChange(row.userid)} />
                            </TableCell>
                            <TableCell>
                                {row.name}
                            </TableCell>
                            <TableCell>
                                {row.userid}
                            </TableCell>
                            <TableCell>
                                {row.count}
                            </TableCell>
                        </TableRow>
                    ))) : (
                        <TableRow>
                            <TableCell colSpan={4} align="center">
                                No users found.
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                </Table>
            </TableContainer>
            </div>
        </Box>
    );
}